module.exports = __webpack_public_path__ + "img/now-serving-heart.b594bd60.svg";